/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CarveOutEligibilityReason } from './CarveOutEligibilityReason';
import {
    CarveOutEligibilityReasonFromJSON,
    CarveOutEligibilityReasonFromJSONTyped,
    CarveOutEligibilityReasonToJSON,
} from './CarveOutEligibilityReason';
import type { CarveOutQuote } from './CarveOutQuote';
import {
    CarveOutQuoteFromJSON,
    CarveOutQuoteFromJSONTyped,
    CarveOutQuoteToJSON,
} from './CarveOutQuote';
import type { CarveOutSource } from './CarveOutSource';
import {
    CarveOutSourceFromJSON,
    CarveOutSourceFromJSONTyped,
    CarveOutSourceToJSON,
} from './CarveOutSource';
import type { CarveOutStatus } from './CarveOutStatus';
import {
    CarveOutStatusFromJSON,
    CarveOutStatusFromJSONTyped,
    CarveOutStatusToJSON,
} from './CarveOutStatus';
import type { CarveOutSubmissionMethod } from './CarveOutSubmissionMethod';
import {
    CarveOutSubmissionMethodFromJSON,
    CarveOutSubmissionMethodFromJSONTyped,
    CarveOutSubmissionMethodToJSON,
} from './CarveOutSubmissionMethod';

/**
 * 
 * @export
 * @interface CarveOut
 */
export interface CarveOut {
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    submission_id: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    lead_medication_id?: string;
    /**
     * 
     * @type {CarveOutSource}
     * @memberof CarveOut
     */
    source: CarveOutSource;
    /**
     * 
     * @type {CarveOutStatus}
     * @memberof CarveOut
     */
    status: CarveOutStatus;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    status_updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    deferred_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    submitted_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    medication_name: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    dosage?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    frequency?: string;
    /**
     * 
     * @type {number}
     * @memberof CarveOut
     */
    cost_per_day?: number;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    j_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    ndc?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    stop_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CarveOut
     */
    notes?: string;
    /**
     * 
     * @type {CarveOutEligibilityReason}
     * @memberof CarveOut
     */
    eligibility_reason: CarveOutEligibilityReason;
    /**
     * Server-computed (Postgres generated column) from j_code and ndc both being present.
     * @type {boolean}
     * @memberof CarveOut
     */
    is_complete: boolean;
    /**
     * The step-2 checkbox state.
     * @type {boolean}
     * @memberof CarveOut
     */
    is_selected_for_submission: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CarveOut
     */
    user_edited_fields: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CarveOut
     */
    can_revert_status: boolean;
    /**
     * 
     * @type {CarveOutSubmissionMethod}
     * @memberof CarveOut
     */
    submission_method?: CarveOutSubmissionMethod;
    /**
     * 
     * @type {Array<CarveOutQuote>}
     * @memberof CarveOut
     */
    quotes?: Array<CarveOutQuote>;
}

/**
 * Check if a given object implements the CarveOut interface.
 */
export function instanceOfCarveOut(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "submission_id" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "medication_name" in value;
    isInstance = isInstance && "eligibility_reason" in value;
    isInstance = isInstance && "is_complete" in value;
    isInstance = isInstance && "is_selected_for_submission" in value;
    isInstance = isInstance && "user_edited_fields" in value;
    isInstance = isInstance && "can_revert_status" in value;

    return isInstance;
}

export function CarveOutFromJSON(json: any): CarveOut {
    return CarveOutFromJSONTyped(json, false);
}

export function CarveOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'submission_id': json['submission_id'],
        'lead_medication_id': !exists(json, 'lead_medication_id') ? undefined : json['lead_medication_id'],
        'source': CarveOutSourceFromJSON(json['source']),
        'status': CarveOutStatusFromJSON(json['status']),
        'status_updated_at': !exists(json, 'status_updated_at') ? undefined : json['status_updated_at'],
        'deferred_at': !exists(json, 'deferred_at') ? undefined : json['deferred_at'],
        'submitted_at': !exists(json, 'submitted_at') ? undefined : json['submitted_at'],
        'medication_name': json['medication_name'],
        'dosage': !exists(json, 'dosage') ? undefined : json['dosage'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'cost_per_day': !exists(json, 'cost_per_day') ? undefined : json['cost_per_day'],
        'j_code': !exists(json, 'j_code') ? undefined : json['j_code'],
        'ndc': !exists(json, 'ndc') ? undefined : json['ndc'],
        'stop_date': !exists(json, 'stop_date') ? undefined : json['stop_date'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'eligibility_reason': CarveOutEligibilityReasonFromJSON(json['eligibility_reason']),
        'is_complete': json['is_complete'],
        'is_selected_for_submission': json['is_selected_for_submission'],
        'user_edited_fields': json['user_edited_fields'],
        'can_revert_status': json['can_revert_status'],
        'submission_method': !exists(json, 'submission_method') ? undefined : CarveOutSubmissionMethodFromJSON(json['submission_method']),
        'quotes': !exists(json, 'quotes') ? undefined : ((json['quotes'] as Array<any>).map(CarveOutQuoteFromJSON)),
    };
}

export function CarveOutToJSON(value?: CarveOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submission_id': value.submission_id,
        'lead_medication_id': value.lead_medication_id,
        'source': CarveOutSourceToJSON(value.source),
        'status': CarveOutStatusToJSON(value.status),
        'status_updated_at': value.status_updated_at,
        'deferred_at': value.deferred_at,
        'submitted_at': value.submitted_at,
        'medication_name': value.medication_name,
        'dosage': value.dosage,
        'route': value.route,
        'frequency': value.frequency,
        'cost_per_day': value.cost_per_day,
        'j_code': value.j_code,
        'ndc': value.ndc,
        'stop_date': value.stop_date,
        'notes': value.notes,
        'eligibility_reason': CarveOutEligibilityReasonToJSON(value.eligibility_reason),
        'is_complete': value.is_complete,
        'is_selected_for_submission': value.is_selected_for_submission,
        'user_edited_fields': value.user_edited_fields,
        'can_revert_status': value.can_revert_status,
        'submission_method': CarveOutSubmissionMethodToJSON(value.submission_method),
        'quotes': value.quotes === undefined ? undefined : ((value.quotes as Array<any>).map(CarveOutQuoteToJSON)),
    };
}

